module.exports = __webpack_public_path__ + "static/media/f2.7fb34f97.png";